import { CompanyLogo } from "../../../components/CompanyLogo";
import { Domain } from "@mui/icons-material";
import { abbreviateNumber } from "../../../utils/numberUtils";
import { OutlinedPaper } from "../../../components/OutlinedPaper";
import { Skeleton } from "../../../components/loading";
import Box from "@mui/material/Box";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

export const CompanyTableCard = (props: {
  productId: number;
  productName: string;
  data: {
    name: string;
    hgId: string;
    url: string;
    countryName: string;
    revenueRange: {
      min: number;
      max: number;
    };
  }[];
  loading: boolean;
}) => {
  const { productName, data, loading } = props;

  return (
    <OutlinedPaper id="company-table" sx={{ p: 2 }}>
      <Box display="flex" gap="4px">
        <Typography variant="h4">Top Customers of</Typography>
        <Skeleton isLoading={loading} width={100} variant="text">
          <Typography variant="h4">{productName}</Typography>
        </Skeleton>
      </Box>
      <Skeleton
        isLoading={loading}
        height={200}
        variant="rectangular"
        margin="14px 0 0 0"
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell color="textSecondary">Company Name</TableCell>
              <TableCell color="textSecondary">URL</TableCell>
              <TableCell color="textSecondary">Country</TableCell>
              <TableCell color="textSecondary">Revenue</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((result, index) => (
              <TableRow key={index}>
                <TableCell>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: 20 }}>
                      <CompanyLogo
                        domain={result.url}
                        size={20}
                        fallback={<Domain />}
                        variant="circular"
                      />
                    </div>
                    <div style={{ marginLeft: 8 }}>{result.name}</div>
                  </div>
                </TableCell>
                <TableCell>{result.url}</TableCell>
                <TableCell>{result.countryName}</TableCell>
                <TableCell>
                  {abbreviateNumber(result.revenueRange.min)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Skeleton>
    </OutlinedPaper>
  );
};
